var _defs, _path, _path2, _path3, _circle, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogEngine32X32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logEngineGradient",
    gradientUnits: "userSpaceOnUse",
    x1: 6,
    y1: 3,
    x2: 29,
    y2: 29
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#B233FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#7B4FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90FF"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6C6 4.34315 10.4772 3 16 3C21.5228 3 26 4.34315 26 6C26 7.65685 21.5228 9 16 9C10.4772 9 6 7.65685 6 6Z",
    stroke: "url(#logEngineGradient)",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6V15M6 15V24M6 15C6 16.6569 10.4772 18 16 18C21.5228 18 26 16.6569 26 15M26 6V15M26 15V24",
    stroke: "url(#logEngineGradient)",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24C6 25.6569 10.4772 27 16 27C21.5228 27 26 25.6569 26 24",
    stroke: "url(#logEngineGradient)",
    strokeWidth: 2.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 3.5,
    stroke: "url(#logEngineGradient)",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 26L29 29",
    stroke: "url(#logEngineGradient)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogEngine32X32);
export default __webpack_public_path__ + "static/media/logEngine-32x32.6e65365b2b4f9ff7d9631ae30c41dd0c.svg";
export { ForwardRef as ReactComponent };